import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import TypeformCalculator from './components/TypeformCalculator';
import FullReportPage from './components/FullReportPage';
import Header from './components/Header';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route
          path="/report"
          element={
            <div className="min-h-screen bg-[#f8f9fc]">
              <FullReportPage />
            </div>
          }
        />
        <Route
          path="*"
          element={
            <div className="min-h-screen bg-[#f8f9fc]">
              <Header />
              <main className="container mx-auto px-4 py-8">
                <TypeformCalculator />
              </main>
              <Footer />
            </div>
          }
        />
      </Routes>
    </HashRouter>
  );
}

export default App;